<template>
  <div>
    <el-form>
      <el-row type="flex" justify="left" style="flex-wrap: wrap;align-items: end">
        <el-col :span="8">
          <el-form-item label="日期(Data)">
            <el-date-picker
              v-model="timeValue"
              :clearable="false"
              end-placeholder="结束时间（Hora de fim）"
              range-separator="-"
              start-placeholder="开始时间（Hora de início）"
              type="daterange"
              value-format="yyyy-MM-dd"
              style="width: 95%" size="small"
              @change="dateChange"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="大区(Região)">
            <el-select
              v-model="queryForm.regionIds"
              placeholder="请选择(Favor selecionar)"
              clearable filterable multiple
              style="width: 95%" collapse-tags
              size="small"
              @change="changeRegion"
            >
              <el-option
                v-for="(item, idx) in regionList"
                :key="idx"
                :label="item.zhName + '（' + item.puName + '）'"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="州(UF)">
            <el-select
              v-model="queryForm.states"
              placeholder="请选择(Favor selecionar)"
              clearable filterable multiple
              :multiple-limit="50" collapse-tags
              style="width: 95%" size="small"
            >
              <el-option
                v-for="(item, idx) in StateList"
                :key="idx"
                :label="item.label"
                :value="item.label"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div style="margin-bottom: 20px">
      <el-button
        type="primary" plain size="small"
        @click="search"
      >查询(Consultar)</el-button>
      <el-button type="primary" size="small" @click="exportAll">导出(Exportar)</el-button>
    </div>
    <el-table
      :data="tableData"
      :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
      border max-height="600" style="width: 100%"
      :span-method="objectSpanMethod"
      :summary-method="getSummaries"
      :row-class-name="tableRowClassName"
      :cell-class-name="cellClassName"
    >
      <el-table-column
        type="index" label="序号(No.)" align="center"
        width="60"
      />
      <el-table-column
        v-for="(item, idx) in tableHeaderList"
        :key="idx"
        align="center"
        :label="item.label"
        :min-width="item.cloWidth"
        :prop="item.prop"
        :show-overflow-tooltip="false"
      >
        <template slot-scope="scope">
          <!-- （为了区分）总计行：按日期；  汇总：按大区  -->
          <div v-if="item.prop === 'lostCount' || item.prop === 'damagedCount' || item.prop === 'lossCount' || item.prop === 'stolenCount'">
            <!-- 非总计行且非汇总行才有点击效果 -->
            <span v-if="scope.row[item.prop]" style="color: #1990ff;cursor: pointer" @click="toDetail(scope.row, item.prop)">
              {{ scope.row[item.prop] }}
            </span>
            <span v-else>--</span>
          </div>
          <div v-else>
            <span>{{ scope.row[item.prop] ? `${scope.row[item.prop]}` : '--' }}</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {
  getLgAreaListData,
  regionQueryList,
  hub2Page,
  hub2Export
} from '@/api/orderApi';
import dayjs from 'dayjs';
import { goRWExportList } from '@/utils/goExportList';

export default {
  data() {
    return {
      cellClassName({ row, column, rowIndex, columnIndex }) {
        // 因为有的dom结构不都是在nth-child(n+4)位置，有可能第三个子标签有可能第四个子标签
        if ((row.isSummary || row.isTotal || row.state === '州总计(Total do Estado)') && columnIndex >= 3) {
          return 'state-summary-cell';
        }
        return '';
      },
      timeValue: [],
      queryForm: {
        startDate: '',
        endDate: '',
        regionIds: [],
        states: []
      },
      regionList: [],
      StateList: [],
      tableData: [],
      tableHeaderList: [
        { label: '日期(Data)', prop: 'statisticDate', cloWidth: '200' },
        { label: '大区(Região)', prop: 'regionName', cloWidth: '130' },
        { label: '州(UF)', prop: 'state', cloWidth: '200' },
        { label: '入库量(Qtd. de entrada)', prop: 'inboundCount', cloWidth: '150' },
        { label: '丢件量(Qtd. de extravio)', prop: 'lostCount', cloWidth: '150' },
        { label: '破损量(Qtd. de itens avariados)', prop: 'damagedCount', cloWidth: '150' },
        { label: '被盗或被抢量(Qtd. de roubo)', prop: 'stolenCount', cloWidth: '150' },
        { label: '丢损量(Qtd. de extravio e avaria)', prop: 'lossCount', cloWidth: '150' },
        { label: '丢件率(Taxa de extravio)', prop: 'lostRate', cloWidth: '150' },
        { label: '破损率(Taxa de avaria)', prop: 'damagedRate', cloWidth: '150' },
        { label: '被盗或被抢率(Taxa de roubo)', prop: 'stolenRate', cloWidth: '150' },
        { label: '丢损率(Taxa de extravio e avaria)', prop: 'lossRate', cloWidth: '150' }
      ]
    };
  },
  created() {
    this.getRegion();
    this.getState();
  },
  methods: {
    toHub2() {
      // 切换界面
      this.default();
      this.search();
    },
    default() {
      const today = dayjs().format('YYYY-MM-DD');
      const oneWeekAgo = dayjs().subtract(6, 'day').format('YYYY-MM-DD');
      this.timeValue = [oneWeekAgo, today];
      this.queryForm.startDate = oneWeekAgo;
      this.queryForm.endDate = today;
    },
    dateChange(val) {
      if (val === null) {
        this.timeValue = [];
        this.queryForm.startDate = '';
        this.queryForm.endDate = '';
        return;
      }
      this.queryForm.startDate = val[0];
      this.queryForm.endDate = val[1];
    },
    // 大区
    getRegion() {
      regionQueryList('').then((res) => {
        if (res.code === 200) {
          this.regionList = res.data;
        }
      });
    },
    // 州
    getState() {
      const params = {
        level: 0,
        parentId: ''
      };
      getLgAreaListData(params, false).then((res) => {
        if (res.code === 200) {
          this.StateList = res.data.map((item) => {
            return {
              id: item.id,
              label: `${item.nameEn}`
            };
          });
        }
      });
    },
    changeRegion(val) {
      // 多选大区，多选州
      this.queryForm.states = [];
      if (val && val.length > 0) {
        const allStates = [];
        val.forEach(regionId => {
          const selectedRegion = this.regionList.find(item => item.id === regionId);
          if (selectedRegion && Array.isArray(selectedRegion.states)) {
            // 将州列表添加到总列表中
            selectedRegion.sites.forEach(state => {
              // 避免重复添加
              if (!allStates.some(s => s.label === state.state)) {
                allStates.push({
                  id: state.id,
                  label: state.state
                });
              }
            });
          }
        });
        this.StateList = allStates;
      } else {
        this.StateList = [];
        this.getState();
      }
    },
    search() {
      if (this.queryForm.startDate && this.queryForm.endDate) {
        hub2Page(this.queryForm).then((res) => {
          if (res.code === 200) {
            const processedData = this.addSummaryRows(res.data);
            // 添加总计行到数据开头
            const totalRow = this.calculateTotalSummary(processedData);
            totalRow.isTotal = true; // 标记为总计行
            this.tableData = [totalRow, ...processedData];
          }
        });
      } else {
        this.$message.warning(this.$t('collectionCenter.selectDate'));
      }
    },
    calculateTotalSummary(data) {
      const totalRow = {
        statisticDate: `${this.queryForm.startDate}~${this.queryForm.endDate}`,
        regionName: '总计(Total)',
        state: '',
        isTotal: true
      };
      const filteredData = data.filter(item => !item.isSummary); // 排除州总计行

      const inboundCount = filteredData.reduce((sum, item) => sum + (Number(item.inboundCount || 0)), 0);
      const lostCount = filteredData.reduce((sum, item) => sum + (Number(item.lostCount || 0)), 0);
      const damagedCount = filteredData.reduce((sum, item) => sum + (Number(item.damagedCount || 0)), 0);
      const lossCount = filteredData.reduce((sum, item) => sum + (Number(item.lossCount || 0)), 0);
      const stolenCount = filteredData.reduce((sum, item) => sum + (Number(item.stolenCount || 0)), 0);

      totalRow.inboundCount = inboundCount;
      totalRow.lostCount = lostCount;
      totalRow.damagedCount = damagedCount;
      totalRow.lossCount = lossCount;
      totalRow.stolenCount = stolenCount;
      const lostRate = inboundCount !== 0 ? ((lostCount / inboundCount) * 100).toFixed(2) + '%' : '0.00%';
      const damagedRate = inboundCount !== 0 ? ((damagedCount / inboundCount) * 100).toFixed(2) + '%' : '0.00%';
      const stolenRate = inboundCount !== 0 ? ((stolenCount / inboundCount) * 100).toFixed(2) + '%' : '0.00%';
      const lossRate = inboundCount !== 0 ? ((lossCount / inboundCount) * 100).toFixed(2) + '%' : '0.00%';
      totalRow.lostRate = lostRate;
      totalRow.damagedRate = damagedRate;
      totalRow.stolenRate = stolenRate;
      totalRow.lossRate = lossRate;

      return totalRow;
    },
    // 添加汇总行的方法
    addSummaryRows(data) {
      if (!data || data.length === 0) return data;

      const result = [];
      const groupedByDate = {};

      // 按日期分组（优先级最高）
      data.forEach(item => {
        if (!groupedByDate[item.statisticDate]) {
          groupedByDate[item.statisticDate] = [];
        }
        groupedByDate[item.statisticDate].push(item);
      });

      // 对每个日期内的数据按大区进行分组
      Object.keys(groupedByDate).forEach(date => {
        const dateData = groupedByDate[date];
        const groupedByRegionInDate = {};

        // 按大区再次分组
        dateData.forEach(item => {
          if (!groupedByRegionInDate[item.regionName]) {
            groupedByRegionInDate[item.regionName] = [];
          }
          groupedByRegionInDate[item.regionName].push(item);
        });

        // 为每个大区添加州总计行
        Object.keys(groupedByRegionInDate).forEach(regionName => {
          const regionData = groupedByRegionInDate[regionName];

          // 只有当该大区对应的数据超过一行时，才添加州总计行
          if (regionData.length > 1) {
            // 计算该大区的州汇总数据
            const summaryRow = this.calculateRegionSummary(regionData);
            summaryRow.isSummary = true; // 标记为汇总行

            // 将州总计行放在该大区数据的最前面
            result.push(summaryRow);
          }

          // 添加原始数据
          result.push(...regionData);
        });
      });

      return result;
    },
    // 计算区域汇总数据
    calculateRegionSummary(regionData) {
      const summary = {
        statisticDate: regionData[0].statisticDate,
        regionId: regionData[0].regionId,
        regionName: regionData[0].regionName,
        state: '州总计(Total do Estado)',
        isSummary: true
      };
      // 汇总数值字段
      const inboundCount = regionData.reduce((sum, item) => sum + (Number(item.inboundCount || 0)), 0);
      const lostCount = regionData.reduce((sum, item) => sum + (Number(item.lostCount || 0)), 0);
      const damagedCount = regionData.reduce((sum, item) => sum + (Number(item.damagedCount || 0)), 0);
      const lossCount = regionData.reduce((sum, item) => sum + (Number(item.lossCount || 0)), 0);
      const stolenCount = regionData.reduce((sum, item) => sum + (Number(item.stolenCount || 0)), 0);

      summary.inboundCount = inboundCount;
      summary.lostCount = lostCount;
      summary.damagedCount = damagedCount;
      summary.lossCount = lossCount;
      summary.stolenCount = stolenCount;
      const lostRate = inboundCount !== 0 ? ((lostCount / inboundCount) * 100).toFixed(2) + '%' : '0.00%';
      const damagedRate = inboundCount !== 0 ? ((damagedCount / inboundCount) * 100).toFixed(2) + '%' : '0.00%';
      const stolenRate = inboundCount !== 0 ? ((stolenCount / inboundCount) * 100).toFixed(2) + '%' : '0.00%';
      const lossRate = inboundCount !== 0 ? ((lossCount / inboundCount) * 100).toFixed(2) + '%' : '0.00%';
      summary.lostRate = lostRate;
      summary.damagedRate = damagedRate;
      summary.stolenRate = stolenRate;
      summary.lossRate = lossRate;

      return summary;
    },
    // 合并行
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        // 日期优先级最高
        return this.calculateSpan1(row, rowIndex, 'statisticDate');
      }
      if (columnIndex === 2) {
        // 其次大区
        return this.calculateSpan2(row, rowIndex, 'regionName', 'statisticDate');
      }
      if (columnIndex === 3) {
        // 州列：如果是州总计行，单独显示一行
        if (row.isSummary && row.state === '州总计(Total do Estado)') {
          return [1, 1]; // 州总计行只占用一行
        }
        // 在同一大区和日期下合并普通州数据
        return this.calculateSpan3(row, rowIndex, 'state', 'regionName', 'statisticDate');
      }
      // 其他列
      return [1, 1];
    },
    // 计算州列合并
    calculateSpan3(row, rowIndex, prop, parentProp, grandParentProp) {
      if (rowIndex > 0 &&
        row[prop] === this.tableData[rowIndex - 1][prop] &&
        row[parentProp] === this.tableData[rowIndex - 1][parentProp] &&
        row[grandParentProp] === this.tableData[rowIndex - 1][grandParentProp]) {
        return [0, 0];
      } else {
        let rowspan = 1;
        for (let i = rowIndex + 1; i < this.tableData.length; i++) {
          if (this.tableData[i][prop] === row[prop] &&
            this.tableData[i][parentProp] === row[parentProp] &&
            this.tableData[i][grandParentProp] === row[grandParentProp]) {
            rowspan++;
          } else {
            break;
          }
        }
        return [rowspan, 1];
      }
    },
    calculateSpan1(row, rowIndex, prop) {
      if (rowIndex > 0 && row[prop] === this.tableData[rowIndex - 1][prop]) {
        return [0, 0];
      } else {
        let rowspan = 1;
        for (let i = rowIndex + 1; i < this.tableData.length; i++) {
          if (this.tableData[i][prop] === row[prop]) {
            rowspan++;
          } else {
            break;
          }
        }
        return [rowspan, 1];
      }
    },
    calculateSpan2(row, rowIndex, prop, parentProp) {
      if (rowIndex > 0 && row[prop] === this.tableData[rowIndex - 1][prop] &&
        row[parentProp] === this.tableData[rowIndex - 1][parentProp]) {
        return [0, 0];
      } else {
        let rowspan = 1;
        for (let i = rowIndex + 1; i < this.tableData.length; i++) {
          if (this.tableData[i][prop] === row[prop] &&
            this.tableData[i][parentProp] === row[parentProp]) {
            rowspan++;
          } else {
            break;
          }
        }
        return [rowspan, 1];
      }
    },
    // 合计行
    getSummaries({ columns, data }) {
      const sums = [];
      // // 日期列：显示开始日期~结束日期
      if (data && data.length > 0) {
        const dates = data.map(item => item.statisticDate).filter(date => date);
        if (dates.length > 0) {
          const sortedDates = dates.sort();
          sums[1] = `${sortedDates[0]}~${sortedDates[sortedDates.length - 1]}`;
        } else {
          sums[1] = `${this.queryForm.startDate}~${this.queryForm.endDate}`;
        }
      } else {
        sums[1] = `${this.queryForm.startDate}~${this.queryForm.endDate}`;
      }
      // 大区列：显示"总计"
      sums[2] = '总计(Total)';
      // 州列：置空
      sums[3] = '';
      // 其余列计算汇总值
      columns.forEach((column, index) => {
        if (index >= 4) {
          if (index === 4) return;
          const prop = column.property;
          if (['inboundCount', 'lostCount', 'damagedCount', 'lossCount', 'stolenCount'].includes(prop)) {
            const values = data.map(item => Number(item[prop] || 0));
            sums[index] = values.reduce((prev, curr) => {
              return prev + curr;
            }, 0);
            sums[index] = sums[index].toLocaleString();
          } else if (['lostRate', 'damagedRate', 'stolenRate', 'lossRate'].includes(prop)) {
            const inboundSum = data.reduce((sum, item) => sum + (Number(item.inboundCount || 0)), 0);
            if (prop === 'lostRate') {
              const lostSum = data.reduce((sum, item) => sum + (Number(item.lostCount || 0)), 0);
              sums[index] = inboundSum !== 0 ? ((lostSum / inboundSum) * 100).toFixed(2) + '%' : '0.00%';
            } else if (prop === 'damagedRate') {
              const damagedSum = data.reduce((sum, item) => sum + (Number(item.damagedCount || 0)), 0);
              sums[index] = inboundSum !== 0 ? ((damagedSum / inboundSum) * 100).toFixed(2) + '%' : '0.00%';
            } else if (prop === 'stolenRate') {
              const stolenSum = data.reduce((sum, item) => sum + (Number(item.stolenCount || 0)), 0);
              sums[index] = inboundSum !== 0 ? ((stolenSum / inboundSum) * 100).toFixed(2) + '%' : '0.00%';
            } else if (prop === 'lossRate') {
              const lossSum = data.reduce((sum, item) => sum + (Number(item.lossCount || 0)), 0);
              sums[index] = inboundSum !== 0 ? ((lossSum / inboundSum) * 100).toFixed(2) + '%' : '0.00%';
            }
          } else {
            sums[index] = ''; // 其他列显示为空
          }
        }
      });
      return sums;
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 0) {
        // 第一行（总计行），除序号列外整行字体加粗
        return 'total-row';
      } else if (row.isSummary || row.isTotal || row.state === '州总计(Total do Estado)') {
        // 包含'州总计'字段的汇总行，应用特殊样式
        return 'state-summary-row';
      }
      return '';
    },
    exportAll() {
      hub2Export(this.queryForm).then((res) => {
        if (res.code === 200) {
          goRWExportList(this);
        }
      });
    },

    toDetail(row, type) {
      const typeVal = type === 'lostCount' ? [1] : type === 'damagedCount' ? [3] : type === 'lossCount' ? [1, 2, 3] : type === 'stolenCount' ? [2] : null;
      const state = row.state === '州总计(Total do Estado)' || !row.state ? '' : row.state;
      let startDate = '';
      let endDate = '';
      if (row.statisticDate.includes('~')) {
        [startDate, endDate] = row.statisticDate.split('~');
      } else {
        startDate = row.statisticDate;
        endDate = row.statisticDate;
      }
      this.$emit('detailData', startDate + ' 00:00:00', endDate + ' 23:59:59', 2, typeVal, state, row.regionId);
    }
  }
};
</script>

<style lang="scss" scoped>
.right{
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
/* 第一行总计行：除序号列外所有列加粗 */
::v-deep .el-table .total-row > td:nth-child(n+2),
::v-deep .el-table .total-row .el-table__cell:nth-child(n+2) {
  font-weight: bold;
  font-size: 15px;
}

/* 州总计行的特定单元格加粗 */
::v-deep .el-table .state-summary-cell {
  font-weight: bold !important;
  font-size: 15px;
}
</style>
